
    import Vue from 'vue';
    // TODO: Descomentar cuando se integren los servicios de emisión y CUPE
    // import CUPEService from '@/apps/shared/services/cupe-service';
    // import MailService from '@/apps/shared/services/email-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import ContractFinish from "@/apps/shared/components/ContractFinish.vue";
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import ParamCotizService from '@/apps/shared/services/ParamCotizOfSession-service';

    // TODO: Definir payload real cuando se integre emisión
    // interface payload {
    //     productId: number;
    //     pricingId: number;
    //     leadId: string;
    //     contratante: {
    //         firstName: string;
    //         lastName: string;
    //         documentNumber: string;
    //         areaCode: string;
    //         telephone: string;
    //         email: string;
    //     };
    //     plan: {
    //         name: string;
    //         priceFormatted: string;
    //     };
    //     travelData: {
    //         destination: any;
    //         departureDate: string;
    //         returnDate: string;
    //         passengersCount: number;
    //     };
    //     referente: string;
    // }

    export default Vue.extend({
        components: {
            ContractFinish
        },
        name: 'TravelAssistanceFinalPayment',
        data() {
            return {
                titleAndPromotionDetails: {
                    icon: {
                        src: '/Icons/check.png',
                    },
                } as TitleAndPromotionsDetails,
                referente: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Asistencia al Viajero';
                const actualPath = '/asistencia-viajero';
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response?.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultTravelAssistanceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            getFilePath() {
                this.$router.push({ name: 'travelAssistance-tab-One' });
            },

            // TODO: Integrar flujo de emisión completo
            // async fetchSessionPayload(guid: string): Promise<void> {
            //     return ParamCotizService.getParamCotiz(guid)
            //         .then(resp => {
            //             if (!resp.hasData || !resp.data) {
            //                 throw new Error(resp.message);
            //             }
            //             this.payload = JSON.parse(resp.data) as payload;
            //         });
            // },

            // TODO: Integrar AddFinishedQuotation + envío de mail
            // async addFinishQuotation() { ... },
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;

                await this.pageCustomization();
                await this.updateByProductGoogleAnalytics();

                // TODO: Descomentar cuando se integre emisión
                // const guid = sessionStorage.getItem('ParamId');
                // if (guid) {
                //     await this.fetchSessionPayload(guid);
                //     await this.addFinishQuotation();
                // }
            } finally {
                NF.UI.Page.unblock();
            }
        },
    });
